import { IntlShape } from 'react-intl'
import * as yup from 'yup'

import { schema as featuresSchema } from 'features/Vehicles/components/FeaturesForm/schema'
import { schema as licensePlatesSchema } from 'features/Vehicles/components/LicensePlatesForm/schema'
import { schema as odometerSchema } from 'features/Vehicles/components/OdometerForm/schema'
import { IVehiclesV2FormStep2Values } from 'features/Vehicles/types'

export const schema = (intl: IntlShape): yup.SchemaOf<IVehiclesV2FormStep2Values> => {
  return yup.object().shape({
    ...featuresSchema().fields,
    ...odometerSchema().fields,
    ...licensePlatesSchema(intl).fields
  })
}
